import { render, staticRenderFns } from "./talent-matrix.vue?vue&type=template&id=06cb45f3&scoped=true&"
import script from "./talent-matrix.vue?vue&type=script&lang=js&"
export * from "./talent-matrix.vue?vue&type=script&lang=js&"
import style0 from "./talent-matrix.vue?vue&type=style&index=0&id=06cb45f3&scoped=true&lang=css&"
import style1 from "./talent-matrix.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb45f3",
  null
  
)

export default component.exports